export default "__VITE_ASSET__D2qRo4uh__"